export default "__VITE_ASSET__3dd91149__"